import i18n from '@/lang';
const $t = (args) => i18n.t(args);

// 从后端返回的全集中剔除的部分
export const EXCLUDE_APP = ['base', 'isrm', 'iomp', 'devicehup'];

export const APP_CONFIG_MAP = {
  // 中央控制系统
  iCCS: {
    description: $t('超级中控|计划排程|专家工艺'),
    enDesc: 'Intelligent Central Control System',
    version: '3.0.0.0'
  },
  // 生产执行系统
  iMES: {
    description: $t('进度管控|员工计件|急单管理'),
    enDesc: 'Intelligent Manufacture Execution System',
    version: '3.0.0.0'
  },
  // 能源管理系统
  iEMS: {
    description: $t('批次能耗|能损管控|能源告警'),
    enDesc: 'IIntelligent Energy Management System',
    version: '3.0.0.0'
  },
  // 质量管理系统
  iQMS: {
    description: $t('成品验布|安灯系统|疵点分析'),
    enDesc: 'Intelligent Quality Management System',
    version: '3.0.0.0'
  },
  // 数据平台
  iSmartBI: {
    description: $t('数据大屏|数字孪生|智能分析'),
    enDesc: 'Intelligent Smart BI data platform',
    version: '3.0.0.0'
  },
  // 仓储管理系统
  iWMS: {
    description: $t('布匹管理|周转分析|缓存管控'),
    enDesc: 'Intelligent Warehouse Management System',
    version: '3.0.0.0'
  },
  // 高级$t('超级中控|计划排程|专家工艺')系统
  iAPS: {
    description: $t('产能中心|瓶颈预测|自动排程'),
    enDesc: 'Intelligent Advanced Planning and Scheduling System',
    version: '3.0.0.0'
  },
  // 全面生产设备管理
  iTPM: {
    description: $t('设备巡检｜设备维修｜预测性维护'),
    enDesc: '',
    version: '3.0.0.0'
  },
  // 输料对接系统
  iCAS: {
    disabled: false,
    description: $t('自动呼料|品牌兼容|无缝对接'),
    enDesc: 'Material transfer docking system',
    version: '3.0.0.0'
  },
  // 实验室管理系统
  iLIMS: {
    disabled: true,
    description: $t('敬请期待'),
    enDesc: '',
    version: '3.0.0.0'
  },
  // 专家工艺库
  iExpert: {
    disabled: false,
    description: $t('智能摆布|智能参数|全工艺库'),
    enDesc: 'Expert craft library',
    version: '3.0.0.0'
  },
  // agv 自动引导运输车管理系统
  iAGV: {
    disabled: false,
    description: $t('库位管理|叉车调度|物流自动化'),
    enDesc: 'Intelligent Logistics System',
    version: '3.0.0.0'
  }
};

export const COMMON_ROUTES = ['/base-config', '/base-data'];
